var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMobile
    ? _c(
        "rb-panel",
        { attrs: { visible: _vm.visible }, on: { closed: _vm.closeLogin } },
        [
          _c("rb-login-panel", {
            attrs: {
              "is-frame-advisor": _vm.fromFrameAdvisor,
              "login-form-is-visible": _vm.loginFormIsVisible,
            },
            on: {
              closeLoginForm: _vm.closeLogin,
              showLoginForm: function ($event) {
                _vm.loginFormIsVisible = true
              },
              showRegisterForm: function ($event) {
                _vm.loginFormIsVisible = false
              },
            },
          }),
        ],
        1
      )
    : _c("rb-login-modal", {
        attrs: {
          visible: _vm.visible,
          "modal-wrapper-class": _vm.getLoginModalWrapperClass,
          "is-frame-advisor": _vm.fromFrameAdvisor,
          "login-form-is-visible": _vm.loginFormIsVisible,
        },
        on: {
          closed: _vm.closeLogin,
          showLoginForm: function ($event) {
            _vm.loginFormIsVisible = true
          },
          showRegisterForm: function ($event) {
            _vm.loginFormIsVisible = false
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }